import React, { useState, useContext, useEffect } from 'react';
import Calendar from '../components/Calendar';
import PersonalCalendar from '../components/PersonalCalendar';
import { UserContext } from '../contexts/UserContext';
import styles from './CalendarPage.module.css';

// localStorage 키
const CALENDAR_TAB_KEY = 'calendar_active_tab';

// SVG 아이콘 컴포넌트
const StudioIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V9z" />
    <polyline points="9 22 9 12 15 12 15 22" />
  </svg>
);

const PersonalIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
    <circle cx="12" cy="7" r="4" />
  </svg>
);

export default function CalendarPage() {
  // eslint-disable-next-line no-unused-vars
  const { userInfo } = useContext(UserContext);

  // 탭 상태: 'studio' | 'personal' - localStorage에서 복원
  const [activeTab, setActiveTab] = useState(() => {
    const saved = localStorage.getItem(CALENDAR_TAB_KEY);
    return saved === 'personal' ? 'personal' : 'studio';
  });

  // 탭 변경 시 localStorage에 저장
  useEffect(() => {
    localStorage.setItem(CALENDAR_TAB_KEY, activeTab);
  }, [activeTab]);

  return (
    <div
      className={styles.pageContainer}
      style={{
        overflow: 'auto',
        isolation: 'isolate',
        zIndex: 0,
        position: 'relative'
      }}
    >
      {/* 탭 UI */}
      <div className={styles.tabContainer}>
        <button
          className={`${styles.tabButton} ${activeTab === 'studio' ? styles.tabActive : ''}`}
          onClick={() => setActiveTab('studio')}
        >
          <StudioIcon />
          <span>GNEGNEGNE</span>
        </button>
        <button
          className={`${styles.tabButton} ${activeTab === 'personal' ? styles.tabActive : ''}`}
          onClick={() => setActiveTab('personal')}
        >
          <PersonalIcon />
          <span>PERSONAL</span>
        </button>
      </div>

      {/* 캘린더 컴포넌트 */}
      {activeTab === 'studio' ? (
        <Calendar />
      ) : (
        <PersonalCalendar />
      )}
    </div>
  );
}
